/**
 * Константы магазинов и маркетплейсов — единый источник правды для бэкенда и фронтенда.
 *
 * До выноса эти enum'ы жили только в project/src/utils/constant.ts, а фронтенд
 * импортировал их напрямую глубоко через `../../../../project/src/utils/constant` (21 место),
 * либо держал собственную копию SHOP_IDENT (front/src/app/reducers/settingsReducer.ts),
 * которая уже отстала на MP_RESALE_OZON. Здесь — каноничные определения.
 */

export enum SHOP {
  "ICON" = "ICON",
  "KATREN" = "KATREN",
  "PODR" = "PODRUZHKA",
  "METRO" = "METRO",
  "SAMSON" = "SAMSON",
  "MP_RESALE_OZON" = "MP_RESALE_OZON",
}

export enum MARKETPLACE {
  "WB" = "wildberries",
  "OZON" = "ozon",
  "YANDEX" = "yandex",
}

export enum MARKETPLACE_IDENT {
  "wildberries" = "WB",
  "ozon" = "OZON",
  "yandex" = "YANDEX",
}

export enum SHOP_IDENT {
  ICON = "ICON",
  KATREN = "KATREN",
  KATREN_OZON = "KATREN_OZON",
  KATREN_YANDEX = "KATREN_YANDEX",
  PODRUZHKA = "PODRUZHKA",
  METRO = "METRO",
  SAMSON = "SAMSON",
  SAMSON_YANDEX = "SAMSON_YANDEX",
  "MP_RESALE_OZON" = "MP_RESALE_OZON",
}

export const SHOP_NAME = {
  ICON: SHOP.ICON,
  KATREN: SHOP.KATREN,
  KATREN_OZON: SHOP.KATREN,
  KATREN_YANDEX: SHOP.KATREN,
  PODRUZHKA: SHOP.PODR,
  METRO: SHOP.METRO,
  SAMSON: SHOP.SAMSON,
  SAMSON_YANDEX: SHOP.SAMSON,
  MP_RESALE_OZON: SHOP.MP_RESALE_OZON,
};

export const MARKETPLACE_NAME = {
  ICON: MARKETPLACE.WB,
  KATREN: MARKETPLACE.WB,
  KATREN_OZON: MARKETPLACE.OZON,
  KATREN_YANDEX: MARKETPLACE.YANDEX,
  PODRUZHKA: MARKETPLACE.WB,
  METRO: MARKETPLACE.WB,
  SAMSON: MARKETPLACE.WB,
  SAMSON_YANDEX: MARKETPLACE.YANDEX,
  MP_RESALE_OZON: MARKETPLACE.WB,
};
